import { NotFoundError } from "@bps/http-client";
import { BhbLocation } from "@stores/bhb/models/BhbLocation.ts";
import type { RootStore } from "@stores/root/RootStore.ts";

export const fetchLocationOrNull = (
  bhb: RootStore["bhb"],
  orgUnitId: string
): Promise<BhbLocation | null> =>
  bhb.getLocation(orgUnitId).catch(error => {
    if (error instanceof NotFoundError) return null;
    throw error;
  });
